import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../utils/constants/api';
import { ApiResponse } from '../../../types/APIResponse';
import { apiEndpoints } from '../../../utils/constants/apiEndpoints';
import { DeleteReason, ReasonType } from '../../../types/ReasonTypes';

// Fetch all found item discard reasons
export const fetchFoundItemDiscardReasons = createAsyncThunk<
    DeleteReason[],
    void,
    { rejectValue: string }
>('foundItemDiscardReasons/fetchAll', async (_, { rejectWithValue }) => {
    try {
        const response = await api.get<ApiResponse<DeleteReason[]>>(apiEndpoints.deleteReason.getAll, { params: { type: ReasonType.Found } });
        return response.data;
    } catch (error: any) {
        return rejectWithValue(error.message || 'Failed to fetch found item discard reasons');
    }
});

// Add new found item discard reason
export const addFoundItemDiscardReason = createAsyncThunk<
    DeleteReason,
    DeleteReason,
    { rejectValue: string }
>('foundItemDiscardReasons/add', async (data, { rejectWithValue }) => {
    try {
        const response = await api.post<ApiResponse<DeleteReason>>(apiEndpoints.deleteReason.create, { data });
        return response.data;
    } catch (error: any) {
        return rejectWithValue(error.message || 'Failed to add found item discard reason');
    }
});

// Update found item discard reason
export const updateFoundItemDiscardReason = createAsyncThunk<
    DeleteReason,
    DeleteReason,
    { rejectValue: string }
>('foundItemDiscardReasons/update', async (data, { rejectWithValue }) => {
    try {
        const response = await api.put<ApiResponse<DeleteReason>>(`${apiEndpoints.deleteReason.update}/${data.id}`, { data: { reason: data.reason, status: data.status, type: ReasonType.Found } });
        return response.data;
    } catch (error: any) {
        return rejectWithValue(error.message || 'Failed to update found item discard reason');
    }
});

// Delete a found item discard reason
export const deleteFoundItemDiscardReason = createAsyncThunk<
    { id: string },
    string,
    { rejectValue: string }
>('foundItemDiscardReasons/delete', async (id, { rejectWithValue }) => {
    try {
        await api.delete(`${apiEndpoints.deleteReason.delete}/${id}`);
        return { id };
    } catch (error: any) {
        return rejectWithValue(error.message || 'Failed to delete found item discard reason');
    }
});
